<template>
    <div class="d-flex flex-column justify-content-between align-items-center min-vh-100 w-100 m-0 spd_background text-center">
        <Header></Header>
        <div class="p-0 text-start mt-5">
            <div class="p-5 mb-4 mt-1 form_box_spd">
                <h2 class="text-center mb-4">REGISTRACE DO VOLEBNÍCH KOMISÍ</h2>
                <p class="my-2"><b>Termín konání:</b> 3. 10. 2025 - 4. 10. 2025</p>
                <p class="my-2"><b>Registrovat se lze do:</b> 28. 8. 2025</p>
                <p class="my-2">Pokud jste se rozhodli pracovat v dny voleb ve volební komisi, zaregistrujte se prosím.</p>
                <p class="my-2">Podmínkou je české občanství a plnoletost.</p>
                <div class="d-flex flex-column flex-md-row justify-content-center mt-4">
                    <button type="submit"
                    class="btn btn-lg btn-primary form_submit_spd"
                    @click="signUp()"
                    >
                        Jste u nás poprvé? Zaregistrujte se
                    </button>
                    <button type="submit"
                    class="btn btn-lg btn-primary form_submit_spd"
                    @click="login()"
                    >
                    Přihlásit se do systému
                    </button>
                </div>
                <p class="text-center mt-3">V případě nejasností se na nás můžete obrátit e-mailem na adrese<br><a href="mailto:registraceovk@spd.cz">registraceovk@spd.cz</a>.</p>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import { CONFIG } from "@/config.js"
import Header from "@/components/spd/Header.vue"
import Footer from "@/components/spd/Footer.vue"
export default {
    components: {
        Header,
        Footer
    },
    data() {
        return {
        }
    },
    methods: {
        login: function () {
            const params = {
                client_id: CONFIG.registerOauthClientId,
                response_type: "code",
                scope: "read",
                redirect_uri: CONFIG.vueAppUrl + "/oauth/callback"
            }
            if (this.$route.query?.path) {
                this.$cookies.set("pathRedirect", this.$route.query.path);
            }
            const queryString = Object.keys(params).map(key => key + '=' + encodeURIComponent(params[key])).join('&');
            window.location.href = CONFIG.api.registerUrl + "/oauth/authorize/?" + queryString;
        },
        signUp: function () {
            window.location.href = CONFIG.registerVueAppUrl + "/sign_up_elections?return_url=" + CONFIG.vueAppUrl + "/register/login";
        },
    }
}
</script>

<style lang="scss">
.election_date {
    font-size: 1.4rem;
    color: #d40000;
    margin-bottom: 1.5rem;
    font-weight: 700;
}

.slogan-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
    flex-wrap: nowrap;
    .line-red {
        height: 4px;
        background-color: red;
        flex: 2;
        max-width: 200px;
    }
    .line-blue {
        height: 4px;
        background-color: #0072ce;
        flex: 1;
        max-width: 100px;
    }
    .slogan-text {
        font-family: 'Protest Riot', cursive;
        font-family: 'Protest Riot', sans-serif;
        font-size: 2rem;
        color: #004080;
        white-space: nowrap;
        padding: 0 1rem;
    }
}
</style>